function vw(num, width) {
    return (num / width * 100).toFixed(4) + 'vw';
}

class HotoGlidesBase extends HTMLElement {
    constructor() {
        super();
        this.windowWidth = window.innerWidth;
        this.glidePCPerView = this.glideMPerView = 1;
        this.glidePCGap = this.glideMGap = 0;
        this.glideData = {
            type: "carousel",
            startAt: 0,
            focusAt: 'center',
            autoplay: 4000
        }
    }

    connectedCallback() {
        this.glideContainer = this.querySelector('.glide');
        this.bindEvents();
        this.initializeGlide();
    }

    bindEvents() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            if (this.windowWidth !== window.innerWidth) {
                this.windowWidth = window.innerWidth;
                this.initializeGlide();
            }
        }, 200);
    }

    countVWGapM() {
        return this.countVWGap(this.glideMGap, 375);
    }

    countVWGapPC() {
        return this.countVWGap(this.glidePCGap, 1920);
    }

    countVWGap(gap, designWidth) {
        return window.innerWidth * gap / designWidth;
    }

    initializeGlide() {
        if (this.glide) {
            this.glide.destroy();
            this.glideData.startAt = this.glide.index;
        }
        let slides = this.querySelectorAll('.glide__slide');
        if (slides.length < 2) {
            return;
        }

        this.glideData.perView = window.innerWidth > 768 ? this.glidePCPerView : this.glideMPerView;
        this.glideData.gap = window.innerWidth > 768 ? this.countVWGapPC() : this.countVWGapM();
        this.glide = new Glide(this.glideContainer, this.glideData);
        this.glideEventsBeforeMount(this.glide);
        this.glide.mount();
    }

    countConstantPerView(slide_width, gap) {
        let glide_width = this.querySelector('.glide').offsetWidth;
        let slide_count = (glide_width + gap) / (slide_width + gap);
        return slide_count;
    }

    glideEventsBeforeMount(glide) {

    }
}

class HotoHeaderM extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.firstMenuHeaders = this.querySelectorAll('.hoto-header-m-menu-item-header');
        this.secondMenuHeaders = this.querySelectorAll('.hoto-header-m-sub-link-header');
        this.toggleBtn = document.querySelector('.hoto-drawer-toggle');
        this.section = this.closest('.hoto-header-m-section');
        this.allSummaries = document.querySelectorAll('[aria-controls]');
        this.announcement = document.querySelector('.shopify-section--announcement-bar');
        this.header = document.querySelector('.shopify-section--header');
        this.overlay = document.querySelector('.hoto-header-m-overlay');
        this.bindEvents();
    }

    bindEvents() {
        this.firstMenuHeaders.forEach(menuHeader => {
            menuHeader.addEventListener('click', (e) => {
                if (e.target.classList.contains('hoto-header-m-menu-link')) {
                    e.stopPropagation();
                    return;
                }
                this.itemClick(menuHeader);
            });
        });
        this.secondMenuHeaders.forEach(menuHeader => {
            menuHeader.addEventListener('click', (e) => {
                if (e.target.classList.contains('hoto-header-m-sub-link-text')) {
                    e.stopPropagation();
                    return;
                }
                this.secondItemClick(menuHeader);
            });
        });
        this.toggleBtn.addEventListener('click', this.toggleBtnClick.bind(this));
        this.addEventListener('click', this.addHeaderIsFilled.bind(this));
        this.addHeaderIsFilledHandle = this.addHeaderIsFilled.bind(this);
        this.addEventListener('click', this.addHeaderIsFilled.bind(this));
        this.allSummaries.forEach(summary => {
            summary.addEventListener('click', () => {
                this.hide();
            });
        });

        this.addEventListener('mouseenter', this.addHeaderIsFilledHandle);

        this.overlay.addEventListener('click', this.hide.bind(this));
    }

    itemClick(menuHeader) {
        const menu = menuHeader.closest('.hoto-header-m-menu-item');
        const menuBody = menu.querySelector('.hoto-header-m-menu-item-body');
        if (menu.classList.contains('hoto-open')) {
            menu.classList.remove('hoto-open');
            menuBody.style.maxHeight = 0;
        } else {
            menu.classList.add('hoto-open');
            menuBody.style.maxHeight = menuBody.scrollHeight + 'px';
        }
    }

    secondItemClick(menuHeader) {
        const menu = menuHeader.closest('.hoto-header-m-menu-item');
        const menuBody = menu.querySelector('.hoto-header-m-menu-item-body');
        const menuBodyHeight = menuBody.scrollHeight;
        const subMenu = menuHeader.closest('.hoto-header-m-sub-link');
        const subMenuBody = subMenu.querySelector('.hoto-header-m-sub-link-body');
        if (subMenu.classList.contains('hoto-open')) {
            subMenu.classList.remove('hoto-open');
            subMenuBody.style.maxHeight = 0;
        } else {
            subMenu.classList.add('hoto-open');
            subMenuBody.style.maxHeight = subMenuBody.scrollHeight + 'px';
        }
        menuBody.style.maxHeight = (menuBodyHeight + subMenuBody.scrollHeight) + 'px';
    }

    toggleBtnClick() {
        if (this.section.classList.contains('hoto-open')) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        const body = document.querySelector('body');
        const header = document.querySelector('.shopify-section-group-header-group.shopify-section--header');
        const store_header = header.querySelector('store-header');
        const headerStyle = window.getComputedStyle(header);
        const headerPosition = headerStyle.getPropertyValue('position');

        if (window.scrollY < 30) {
            let announcement_bar_height_left = 0;
            if (this.announcement != null) {
                announcement_bar_height_left = this.announcement.offsetHeight - window.scrollY;
                announcement_bar_height_left = announcement_bar_height_left.toFixed(2);
            }
            header.style.setProperty('--announcement-bar-height', announcement_bar_height_left + 'px');
        }
        console.log(window.scrollY, 'window.scrollY F')

        this.section.classList.add('hoto-open');
        header.classList.add('hoto-drawer-open');
        this.addHeaderIsFilled();
        body.style.overflow = 'hidden';
        this.closing = false;




        if (headerPosition != 'sticky' || window.scrollY < 30) {
            this.section.classList.remove('hoto-sticky');
        } else {
            this.section.classList.add('hoto-sticky');
        }

        header.addEventListener('click', this.addHeaderIsFilledHandle);
        header.addEventListener('mouseenter', this.addHeaderIsFilledHandle);

        store_header.addEventListener('click', this.addHeaderIsFilledHandle);
        store_header.addEventListener('mouseenter', this.addHeaderIsFilledHandle);

        // this.watchingHeader();
        this.announcement.addEventListener('mouseenter', this.addHeaderIsFilledHandle);
        this.announcement.addEventListener('click', this.addHeaderIsFilledHandle);
    }

    hide() {
        const body = document.querySelector('body');
        const header = document.querySelector('.shopify-section-group-header-group.shopify-section--header');
        const headerStyle = window.getComputedStyle(header);
        const headerPosition = headerStyle.getPropertyValue('position');
        this.section.classList.remove('hoto-open');
        header.classList.remove('hoto-drawer-open');
        body.style.overflow = 'auto';
        header.removeEventListener('click', this.addHeaderIsFilledHandle);
        header.removeEventListener('mouseenter', this.addHeaderIsFilledHandle);
        this.closing = true;
        if (headerPosition != 'sticky' || window.scrollY < 30) {
            setTimeout(() => {
                if (this.closing) {
                    this.removeHeaderIsFilled();
                    header.style.removeProperty('--announcement-bar-height');
                    // if (this.watching) {
                    //     clearInterval(this.watching);
                    // }
                }
            }, 500);
        }

        const store_header = header.querySelector('store-header');
        store_header.removeEventListener('click', this.addHeaderIsFilledHandle);
        store_header.removeEventListener('mouseenter', this.addHeaderIsFilledHandle);

        this.announcement.removeEventListener('mouseenter', this.addHeaderIsFilledHandle);
        this.announcement.removeEventListener('click', this.addHeaderIsFilledHandle);
    }

    addHeaderIsFilled() {
        const store_header = document.querySelector('store-header');
        setTimeout(() => {
            store_header.classList.add('is-filled');
        }, 10);
    }

    removeHeaderIsFilled() {
        const store_header = document.querySelector('store-header');
        store_header.classList.remove('is-filled');
    }

    watchingHeader() {
        if (this.watching) {
            clearInterval(this.watching);
        }
        this.watching = setInterval(() => {
            if (this.section.classList.contains('hoto-open')) {
                this.addHeaderIsFilled();
            } else {
                this.removeHeaderIsFilled();
                if (this.watching) {
                    clearInterval(this.watching);
                }
            }
        }, 500);
    }
}
customElements.define('hoto-header-m', HotoHeaderM);

class HotoHeaderPcNav extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.hoto-header-pc-nav-item');
        this.sub_product_links = this.querySelectorAll('.hoto-header-pc-nav-item-dropdown-sub-link');
        this.storeHeader = document.querySelector('store-header');
        this.bindEvents();
    }

    bindEvents() {
        this.items.forEach(item => {
            item.addEventListener('mouseenter', () => {
                this.onMouseEnterItem(item);
            });
        });

        this.addEventListener('mouseleave', () => {
            this.onMouseLeaveItem();
        });

        this.sub_product_links.forEach(item => {
            item.addEventListener('mouseenter', () => {
                this.onMouseEnterProductSubLink(item);
            });
        });
    }

    onMouseEnterItem(item) {
        this.storeHeader.classList.add('is-filled');
        const hovering = this.querySelector('.hoto-header-pc-nav-item.hoto-hover');
        if (hovering != item) {
            item.classList.add('hoto-hover');
            if (hovering) {
                hovering.classList.remove('hoto-hover');
            }
        }
        this.watchingHeader();
    }

    onMouseLeaveItem() {
        this.storeHeader.classList.remove('is-filled');
        this.items.forEach(item => {
            item.classList.remove('hoto-hover');
        });

        if (this.watching) {
            clearInterval(this.watching);
        }
    }

    onMouseEnterProductSubLink(item) {
        const id = item.dataset.hotoDropdownId;
        const item_container = item.closest('.hoto-header-pc-nav-item-dropdown-container-products');
        const item_container_products = item_container.querySelectorAll('.hoto-header-pc-nav-item-products');
        item_container_products.forEach(product => {
            if (product.dataset.hotoDropdownId == id) {
                product.classList.add('hoto-show');
            } else {
                product.classList.remove('hoto-show');
            }
        });
        const links = item_container.querySelectorAll('.hoto-header-pc-nav-item-dropdown-sub-link');
        links.forEach(link => {
            if (link.dataset.hotoDropdownId == id) {
                link.classList.add('hoto-active');
            } else {
                link.classList.remove('hoto-active');
            }
        });
    }

    addHeaderIsFilled() {
        const store_header = document.querySelector('store-header');
        store_header.classList.add('is-filled');
    }

    removeHeaderIsFilled() {
        const store_header = document.querySelector('store-header');
        store_header.classList.remove('is-filled');
    }

    watchingHeader() {
        if (this.watching) {
            clearInterval(this.watching);
        }
        this.watching = setInterval(() => {
            if (this.querySelector('.hoto-header-pc-nav-item.hoto-hover')) {
                this.addHeaderIsFilled();
            } else {
                this.removeHeaderIsFilled();
                if (this.watching) {
                    clearInterval(this.watching);
                }
            }
        }, 500);
    }

}
customElements.define('hoto-header-pc-nav', HotoHeaderPcNav);

class HotoSlideReviews extends HotoGlidesBase {
    constructor() {
        super();
        this.glidePCPerView = 3;
        this.glideMPerView = 1.1;
        this.glidePCGap = 16;
        this.glideMGap = 0;
    }

    countVWGapM() {
        return this.glideMGap;
    }

    countVWGapPC() {
        return this.glidePCGap;
    }

    initializeGlide() {
        if (window.innerWidth < 768) {
            this.glideData = {
                type: "carousel",
                startAt: 0,
                rewind: false
            }
        }

        super.initializeGlide();
    }
}
customElements.define('hoto-slide-reviews', HotoSlideReviews);

class HotoSlideBlogs extends HotoSlideReviews {
    constructor() {
        super();
    }

    initializeGlide() {
        if (window.innerWidth >= 768) {
            if (this.glide) {
                this.glide.destroy();
                this.glide = null;
            }
        } else {
            super.initializeGlide();
        }
    }
}
customElements.define('hoto-slide-blogs', HotoSlideBlogs);

class HotoSlideBrands extends HotoGlidesBase {
    constructor() {
        super();
        this.glidePCPerView = 5;
        this.glideMPerView = 1.76;
        this.glidePCGap = 24;
        this.glideMGap = 60;
        this.glideData.autoplay = 100;
        this.glideData.animationDuration = 1000;
    }

    countVWGapM() {
        return this.glideMGap;
    }

    countVWGapPC() {
        return this.glidePCGap;
    }
}
customElements.define('hoto-slide-brands', HotoSlideBrands);

class HotoBanner extends HotoGlidesBase {
    constructor() {
        super();

        this.glideData.autoplay = false;
    }

    bindEvents() {
        super.bindEvents();

        this.videos = this.querySelectorAll('video');
        this.videos.forEach((video) => {
            video.addEventListener('ended', () => {
                this.glide.go(">");
            });
        });

        this.images = this.querySelectorAll('img');

        this.items = this.querySelectorAll('.hoto-banner-item');
        if (this.items.length == 1) {
            this.videos.forEach(video => {
                video.loop = true;
                video.play();
            });
        }
    }

    glideEventsBeforeMount(glide) {
        super.glideEventsBeforeMount(glide);
        glide.on(["mount.after", "run"], () => {
            this.onSlideChange();
        });
    }

    getVideobyIndex(index) {
        let video = null;
        if (window.innerWidth > 768) {
            video = this.items[index].querySelector('video.hoto-hidden-mobile');
        } else {
            video = this.items[index].querySelector('video.hoto-hidden-desktop');
        }
        return video;
    }

    getImagetypebyIndex(index) {
        let image = null;
        if (window.innerWidth > 768) {
            image = this.items[index].querySelector('img.hoto-hidden-mobile');
        } else {
            image = this.items[index].querySelector('img.hoto-hidden-desktop');
        }
        return image;
    }

    playImage(image) {
        if (this.imagePlaying) {
            clearTimeout(this.imagePlaying);
        }
        let duration = Number(image.dataset.hotoDuration);
        this.imagePlaying = setTimeout(() => {
            this.glide.go(">");
            clearTimeout(this.imagePlaying);
            this.imagePlaying = null;

        }, duration * 1000);
    }

    onSlideChange() {
        this.items.forEach((item, index) => {
            let video = this.getVideobyIndex(index);
            if (index === this.glide.index) {
                if (video) {
                    video.play();
                } else {
                    let image = this.getImagetypebyIndex(index);
                    if (image) {
                        setTimeout(() => {
                            this.playImage(image);
                        }, 500);
                    }
                }
            } else {
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        });
    }

}
customElements.define('hoto-banner', HotoBanner);

class HotoSmallListImageInfo extends HotoGlidesBase {
    constructor() {
        super();

        this.glideData = {
            type: "slider",
            startAt: 0,
            focusAt: 0,
            autoplay: false,
            bound: true,
            rewind: false
        }
    }

    countVWGapM() {
        return 16;
    }

    countVWGapPC() {
        return 16;
    }

    initializeGlide() {
        if (window.innerWidth >= 768) {
            if (this.glide) {
                this.glide.destroy();
                this.glide = null;
            }
        } else {
            this.glideMPerView = this.countConstantPerView(80, 8);
            let total_items = this.querySelectorAll('.glide__slide').length;
            let total_width = total_items * 80;
            let container_width = this.glideContainer.offsetWidth;
            if (total_width > container_width - 32) {
                super.initializeGlide();
                this.glideContainer.classList.remove('hoto-not-init')
            } else {
                this.glideContainer.classList.add('hoto-not-init');
                if (this.glide) {
                    this.glide.destroy();
                    this.glide = null;
                }
            }
        }
    }
}
customElements.define('hoto-small-list-image-info', HotoSmallListImageInfo)

class HotoBigMediaInfo extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.container = this.querySelector('.hoto-big-media-info-container');
        this.play_btn = this.querySelector('.hoto-big-media-info-play-btn');
        this.pause_btn = this.querySelector('.hoto-big-media-info-pause-btn');

        this.bindEvents();
        this.initObserver();
    }

    bindEvents() {
        this.play_btn?.addEventListener('click', () => {
            this.container.classList.add('hoto-playing');
            this.container.classList.remove('hoto-paused');
            let index = window.innerWidth > 768 ? 0 : 1;
            let video = this.container.querySelectorAll('video')[index];
            if (video) {
                video.play();
            }
        });

        this.pause_btn?.addEventListener('click', () => {
            this.container.classList.remove('hoto-playing');
            this.container.classList.add('hoto-paused');
            let videos = this.container.querySelectorAll('video');
            videos.forEach(video => {
                video.pause();
            });
        });
    }

    initObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.8
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.play_btn?.click();
                }
            });
        }, options);

        this.observer.observe(this.container);
    }

    disconnectedCallback() {
        if (this.observer) {
            this.observer.unobserve(this.container);
        }
    }

}
customElements.define('hoto-big-media-info', HotoBigMediaInfo);

class HotoSlideImageInfo extends HotoGlidesBase {
    constructor() {
        super();

        this.glidePCPerView = 3;

        this.glideData = {
            type: "slider",
            startAt: 0,
            focusAt: 0,
            autoplay: false,
            bound: true,
            rewind: false
        }
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.hoto-slide-image-info-item');
        super.connectedCallback();
    }

    bindEvents() {
        super.bindEvents();
        this.items.forEach(item => {
            let item_videos = item.querySelectorAll('video');
            if (item_videos.length > 0) {
                let play_btn = item.querySelector('.hoto-slide-image-info-item-play-btn');
                play_btn.addEventListener('click', () => {
                    let videos = this.querySelectorAll('.hoto-slide-image-info-item video');
                    videos.forEach(video => {
                        if (video.classList.contains('hoto-playing')) {
                            video.pause();
                            video.closest('.hoto-slide-image-info-item').classList.remove('hoto-playing');
                            video.closest('.hoto-slide-image-info-item').classList.add('hoto-paused');
                        }
                    });
                    this.items.forEach(item => {
                        item.classList.remove('hoto-playing');
                    });
                    item.classList.add('hoto-playing');
                    item.classList.remove('hoto-paused');
                    let video = item_videos[window.innerWidth > 768 ? 0 : 1];
                    video.play();
                });

                let pause_btn = item.querySelector('.hoto-slide-image-info-item-pause-btn');
                pause_btn.addEventListener('click', () => {
                    let video = item_videos[window.innerWidth > 768 ? 0 : 1];
                    video.pause();
                    item.classList.remove('hoto-playing');
                    item.classList.add('hoto-paused');
                });
            }
        });
    }

    countVWGapPC() {
        return 16;
    }

    countVWGapM() {
        return 16;
    }

    initializeGlide() {
        this.glideMPerView = this.countConstantPerView(290, 16);
        super.initializeGlide();
    }

}
customElements.define('hoto-slide-image-info', HotoSlideImageInfo);

class HotoSlideVideoInfo extends HotoSlideImageInfo {
    constructor() {
        super();
    }

    bindEvents() {
        super.bindEvents();
        this.play_btns = this.querySelectorAll('.hoto-slide-video-info-item-play-btn');
        this.play_btns.forEach(btn => {
            btn.addEventListener('click', () => {
                let item = btn.closest('.hoto-slide-video-info-item');
                let items = this.querySelectorAll('.hoto-slide-video-info-item');
                items.forEach(_item => {
                    this.pauseVideo(_item);
                });
                this.playVideo(item);
            });
        });

        this.pause_btns = this.querySelectorAll('.hoto-slide-video-info-item-pause-btn');
        this.pause_btns.forEach(btn => {
            btn.addEventListener('click', () => {
                let item = btn.closest('.hoto-slide-video-info-item');
                this.pauseVideo(item);
            });
        });
    }

    playVideo(item) {
        item.classList.add('hoto-playing');
        item.classList.remove('hoto-paused');
        let index = window.innerWidth > 768 ? 0 : 1;
        let video = item.querySelectorAll('video')[index];
        if (video) {
            video.play();
        }
    }


    pauseVideo(item) {
        item.classList.remove('hoto-playing');
        item.classList.add('hoto-paused');
        let videos = item.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
        });
    }
}
customElements.define('hoto-slide-video-info', HotoSlideVideoInfo);

class HotoSlideMediaProduct extends HotoSlideImageInfo {
    constructor() {
        super();
    }

    bindEvents() {
        super.bindEvents();
        this.play_btns = this.querySelectorAll('.hoto-slide-media-product-item-play-btn');
        this.play_btns.forEach(btn => {
            btn.addEventListener('click', () => {
                let item = btn.closest('.hoto-slide-media-product-item');
                let items = this.querySelectorAll('.hoto-slide-media-product-item');
                items.forEach(_item => {
                    this.pauseVideo(_item);
                });
                this.playVideo(item);
            });
        });

        this.pause_btns = this.querySelectorAll('.hoto-slide-media-product-item-pause-btn');
        this.pause_btns.forEach(btn => {
            btn.addEventListener('click', () => {
                let item = btn.closest('.hoto-slide-media-product-item');
                this.pauseVideo(item);
            });
        });
    }

    playVideo(item) {
        item.classList.add('hoto-playing');
        item.classList.remove('hoto-paused');
        let index = window.innerWidth > 768 ? 0 : 1;
        let video = item.querySelectorAll('video')[index];
        if (video) {
            video.play();
        }
    }


    pauseVideo(item) {
        item.classList.remove('hoto-playing');
        item.classList.add('hoto-paused');
        let videos = item.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
        });
    }
}
customElements.define('hoto-slide-media-product', HotoSlideMediaProduct);

class HotoLineSlideImage extends HTMLElement {
    constructor() {
        super();
        this.windowWidth = window.innerWidth;
    }

    connectedCallback() {
        this.swiperContainer = this.querySelector('.swiper');
        this.bindEvents();
        this.initializeSwiper();
        this.updateSwiper();
    }

    bindEvents() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            if (this.windowWidth !== window.innerWidth) {
                this.windowWidth = window.innerWidth;
                this.updateSwiper();
            }
        }, 200);
    }

    initializeSwiper() {
        this.swiper = new Swiper(this.swiperContainer, {
            slidesPerView: 2,
            spaceBetween: 16,
            allowTouchMove: false,
            freeMode: false,
            centeredSlides: true,
            loop: true,
            loopedSlides: 8,
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            speed: 5000,
            breakpoints: {
                768: {
                    slidesPerView: 6,
                    spaceBetween: 16,
                    centeredSlides: false,
                }
            },

        });
    }

    updateSwiper() {
        if (!this.swiper) return;
        this.swiper.update();
    }
}

customElements.define('hoto-line-slide-image', HotoLineSlideImage);